// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Agents extends APIResource {
    /**
     * Get all agent IDs that have the specified folder attached.
     */
    list(folderID, query = {}, options) {
        return this._client.get(path `/v1/folders/${folderID}/agents`, { query, ...options });
    }
}
//# sourceMappingURL=agents.mjs.map